<template>
    <PopupWrapper
        title="請輸入您的活動參與資訊"
        close
        @close="$emit('close')"
        @confirm="onConfirm"
    >
        <InputWrapper
            v-model="data[input.fieldName]"
            v-for="(input, i) in inputs"
            :key="`input${i}`"
            :ref="`input${i}`"
            :label="input.label"
            :placeholder="input.placeholder"
            :rules="input.rules"
        />
        <template v-slot:dialog>
            <AlertWrapper
                v-if="joinEventError"
                title="加入活動失敗"
                :content="joinEventError"
                @close="joinEventError = null"
            />
        </template>
    </PopupWrapper>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import PopupWrapper from '@/components/Wrapper/PopupWrapper.vue';
import InputWrapper from '@/components/Wrapper/InputWrapper.vue';
import AlertWrapper from '@/components/Wrapper/AlertWrapper.vue';
import Sdk from '@/sdk';

export default {
    props: {
        eventId: String,
    },
    components: { PopupWrapper, InputWrapper, AlertWrapper },
    data() {
        return {
            data: {},
            joinEventError: null,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.user,
        }),
        inputs() {
            const fields = [
                {
                    label: '活動代碼',
                    fieldName: 'code',
                    placeholder: '請輸入活動代碼',
                    rules: {
                        required: true,
                    },
                },
                {
                    label: '暱稱',
                    fieldName: 'name',
                    placeholder: '請輸入名稱',
                    rules: {
                        required: true,
                    },
                },
            ];
            if (this.eventId) return _.drop(fields);
            return fields;
        },
        isValid() {
            let isValid = true;
            const LENGTH = this.inputs.length;
            for (let i = 0; i < LENGTH; i += 1) {
                const REF = this.$refs[`input${i}`][0];
                if (!REF.validate() && isValid) isValid = false;
            }
            return isValid;
        },
    },
    methods: {
        init() {
            if (_.isEmpty(this.data?.name)) this.$set(this.data, 'name', this.user?.name);
        },
        async onConfirm() {
            try {
                if (this.isValid) {
                    await Sdk.joinEvent({
                        eventId: this.eventId,
                        code: this.data?.code,
                        name: this.data?.name,
                    });
                    this.$emit('close');
                }
            } catch ({ response }) {
                this.joinEventError = response.data.message;
            }
        },
    },
    created() {
        this.init();
    },
    watch: {
        user() {
            this.init();
        },
    },
};
</script>

<style lang="scss" scoped>
.button-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
